export interface Experience {
  id: string;
  title: string;
  company: string;
  location: string;
  type: string;
  startDate: string;
  endDate: string;
  description: string;
  skills: string[];
  achievements: string[];
  impact: string;
  isRemote?: boolean;
}

export const experiences: Experience[] = [
  {
    id: "laposte",
    title: "Lead dev Full-stack JS/React/Next.JS",
    company: "La Poste Groupe",
    location: "Paris, France",
    type: "Freelance",
    startDate: "2022-02-01",
    endDate: "present",
    description:
      "Okapi est la plateforme centralisée permettant aux développeurs d'accéder aux" +
      " API du Groupe La Poste en self-service. Ce hub facilite l'intégration," +
      " le monitoring et la supervision des consommations d'API. J'ai été engagé" +
      " comme lead dev full-stack pour la refonte de l’application web. ",
    skills: [
      "TypeScript",
      "React.js",
      "Next.js",
      "Express.js",
      "GraphQL",
      "Tailwind CSS",
      "Docker",
      "Kubernetes",
      "Gitalab CI/CD",
      "Node.js",
      "Prisma",
      "MongoDB",
      "Ansible",
      "Redis",
      "MERN Stack",
      "Test e2e (cypress)",
      "Test unitaire (jest)",
      "Storybook",
      "TDD/E2E",
      "Methode Agile",
    ],
    achievements: [
      "Refonte technique de l'application, migration de l'application vers TypeScript et adoption de Next.js " +
        "pour améliorer les performances et la scalabilité",
      "Création de l’architecture des l’applications frontend et réalisation des schemas de conception",
      "Participation au développement backend pour assurer une bonne intégration des fonctionnalités.",
      "Développement d'un back-office complet permettant la gestion et le suivi des API",
      "Mise en place d'un Design System et amélioration de l'ergonomie",
      "Création de librairies partagées pour faciliter l'utilisation et la maintenance de " +
        "l'application avec la mise a disposition sur un registry privé.",
      "Travail en étroite collaboration avec les équipes UI/UX de La Poste",
      "Mise en place de tests unitaires & e2e pour garantir la stabilité et la maintenabilité",
      "Animation de réunions techniques, mentoring et accompagnement des développeurs",
      "Relecture de code et amélioration continue via des PR reviews rigoureuses.",
      "Automatisation complète via CI/CD & Docker, assurant une mise en production fluide et sécurisée.",
    ],
    impact:
      "Okapi simplifie l'accès aux API du Groupe La Poste, réduisant considérablement le temps" +
      " d'intégration des partenaires et optimisant la supervision des flux API. La refonte technique" +
      " a amélioré la performance et la scalabilité de l’application, ainsi que la qualité du code.",
    isRemote: true,
  },
  {
    id: "afone-noelse",
    title: "Tech Lead Full-stack JS/React/Next.JS",
    company: "Afone Paiement",
    location: "Angers, France",
    type: "Freelance",
    startDate: "2020-01-01",
    endDate: "2022-02-01",
    description:
      "Nøelse est une néobanque proposant des services bancaires et de paiement innovants. " +
      "J'ai dirigé le développement des applications web et mobile pour ce projet stratégique d'Afone Paiement. " +
      "Ma mission consistait notamment en la mise en place d'une architecture monorepo, " +
      "Création de l'application web ainsi que la gestion de la qualité et la fiabilité du déploiement moderne.",
    skills: [
      "TypeScript",
      "React.js",
      "Next.js",
      "Express.js",
      "Node.js",
      "Kubernetes",
      "Docker",
      "React Native",
      "Cypress",
      "Jest",
      "CI/CD",
      "Storybook",
      "Monorepo",
      "TDD/E2E",
      "API REST",
      "Methode Agile",
    ],
    achievements: [
      "Mise en place de la stack technique et collaboration avec le Lead Dev mobile pour la définition d'un monorepo " +
        "afin de partager le code entre les applications web et mobile basées sur ReactJS",
      "Mise en place de tests unitaires & e2e pour garantir la stabilité et la maintenabilité",
      "Participation au développement backend pour assurer une bonne intégration des fonctionnalités.",
      "Mise en place d'un Storybook, et création d'une librairy de composants react.js.",
      "Réalisation de code reviews régulières et formation des développeurs pour garantir la qualité du code et le respect des bonnes pratiques.",
      "Automatisation complète via CI/CD & Docker, assurant une mise en production fluide et sécurisée",
      "Intégration d’outils de KPI pour mesurer et améliorer la performance des applications.",
      "Création de l'application web ainsi que la gestion de la qualité et la fiabilité du deploiement moderne",
      "Animation de réunions techniques, mentoring et accompagnement des développeurs.",
      "Relecture de code et amélioration continue via des PR reviews rigoureuses.",
      "Travail en étroite collaboration avec les équipes UI/UX de Nøelse.",
    ],
    impact:
      "Nøelse a permis à Afone de réaliser sa transition vers le secteur bancaire tout en optimisant" +
      " le développement et le déploiement des applications grâce à un code partagé, des tests rigoureux et " +
      "une automatisation efficace.",
    isRemote: true,
  },
  {
    id: "afone-papam",
    title: "Lead dev Full-stack JS/PHP",
    company: "Afone Paiement",
    location: "Angers, France",
    type: "Freelance",
    startDate: "2019-10-01",
    endDate: "2020-01-01",
    description:
      "Papam est une solution de paiement numérique permettant des transactions par mail, similaire à PayPal. Elle vise " +
      "à simplifier les paiements pour les particuliers et les professionnels, avec une interface web intuitive. " +
      "Ce projet a impliqué une collaboration étroite au sein d'une équipe pluridisciplinaire pour répondre aux besoins de " +
      "l'entreprise et garantir une solution fiable et évolutive. La mission consistait notamment en la refonte " +
      "technique, la gestion de la qualité et la fiabilité avec une architecture moderne et une mise en place de tests rigoureux.",
    skills: [
      "TypeScript",
      "React.js",
      "Next.js",
      "React Native",
      "PHP",
      "Vue.js",
      "MySQL",
      "Docker",
      "CI/CD",
      "Cypress",
      "Jest",
    ],
    achievements: [
      "Management d’une équipe de 6 développeurs front-end et collaboration étroite avec les équipes back-end.",
      "Participation au développement backend pour assurer une bonne intégration des fonctionnalités.",
      "Participation active au développement de l’application sur une base Laravel PHP, en mettant l’accent sur la qualité du code et la scalabilité de l’application.",
      "Organisation de code reviews, formation des développeurs et mise en place de bonnes pratiques de développement.",
      "Développement de tests unitaires et fonctionnels pour garantir la fiabilité et la stabilité de l'application.",
      "Mise en place d’outils de KPI pour suivre l’évolution du projet et optimiser ses performances.",
      "Rédaction de la documentation technique et animation de réunions techniques pour garantir la compréhension et la mise en œuvre des solutions proposées.",
      "Définition et mise en place de l'architecture technique du projet.",
    ],
    impact:
      "Le refonte du développement de Papam a permis à Afone de proposer une solution de paiement numérique" +
      " fiable et performante, tout en préparant l'entreprise à son futur projet Nøelse," +
      " sur lequel j'ai continué à intervenir en tant que Tech Lead.",
  },
  {
    id: "orkeis",
    title: "Développeur Full-stack JS/PHP/C#",
    company: "Orkeis",
    location: "Angers, France",
    type: "CDI",
    startDate: "2017-10-01",
    endDate: "2019-10-01",
    description:
      "Orkeis est une ESN spécialisée dans l’accompagnement numérique des entreprises, offrant une large gamme de " +
      "services allant de la configuration et du paramétrage logiciel à la maintenance et le développement " +
      "de solutions innovantes, telles que la réalité augmentée. J'ai travaillé sur plusieurs projets, notamment " +
      "les applications web pour divers clients, ainsi que des applications de gestion complexes " +
      "pour des entreprises de grande taille.",
    skills: ["React.js", "Laravel", "Framework Symfony", "PHP", "jQuery", "C#", "MySQL", "PGSQL", ".NET"],
    achievements: [
      "Maintien et développement de projets existants sur PHP (notamment avec le framework Symfony) et formation des collaborateurs internes sur cette technologie.",
      "Réalisation de nouvelles applications, allant de petites solutions" +
        " événementielles à des applications de gestion complexes",
      "Bicompétence PHP/C#, Participation aux projets .NET grâce à ma double compétence",
      "Formation des équipes internes sur le développement PHP et accompagnement sur les bonnes pratiques.",
      "Déboguage et correction de bugs dans les applications existantes.",
    ],
    impact:
      " Avec ma contribution sur des projets divers et mon rôle de référant PHP interne, j’ai permis à l’entreprise " +
      "de maintenir et de faire évoluer efficacement ses solutions tout en assurant la montée en compétences des développeurs sur PHP.",
  },
  {
    id: "sopra",
    title: "Développeur web",
    company: "Sopra Steria",
    location: "Saint-Herblain, France",
    type: "Alternance",
    startDate: "2016-10-01",
    endDate: "2017-10-01",
    description:
      "Sopra Steria est une entreprise de services du numérique (ESN) de renommée internationale. J’ai intégré un " +
      "projet d’envergure pour Enedis, une application existante depuis plus de 10 ans, en Java (back) et Typescript " +
      "(front), au sein d’une équipe de 50 à 70 développeurs. Ma contribution consistait essentiellement à la " +
      "correction de bugs et en mise en place de nouvelles fonctionnalités.",
    skills: ["ASP.NET MVC", "C#", "JavaScript", "Typescript", "jQuery", "SQL Server", "Symfony", "SQL", "PostgreSQL"],
    achievements: [
      "Correction des bugs urgents en production et stabilisation du code.",
      "Écriture de scripts SQL pour la reprise de données suite à des erreurs logicielles.",
      "Participation à la transition de l’entreprise, passant d’un cycle en V à une gestion Agile des projets.",
      "Immersion dans une grande équipe et découverte des processus structurés d’une ESN de grande envergure.",
    ],
    impact:
      "J’ai contribué à la maintenance et à l’amélioration d’un projet critique tout en découvrant les méthodologies de" +
      " gestion de projet d’une grande entreprise, enrichissant ainsi ma vision du développement logiciel à grande échelle.",
  },
  {
    id: "strego",
    title: "Développeur web",
    company: "Groupe Strego",
    location: "Angers, France",
    type: "Alternance",
    startDate: "2014-09-01",
    endDate: "2016-09-01",
    description:
      "Strego est un cabinet d’expertise comptable disposant d’un service DSI interne. J’ai rejoint une équipe " +
      "de 4 personnes pour travailler sur des outils internes destinés aux comptables, en utilisant ASP.NET " +
      "et ASP.NET MVC. Ma contribution consistait essentiellement à la conception et au développement de " +
      "nouveaux outils et à leur mise en production. Aussi, j’ai travaillé sur des projets existants, notamment " +
      "en utilisant des technologies Microsoft et open source.",
    skills: ["ASP.NET MVC", "Symfony", "PHP", "JavaScript", "C#", "SQL", "PostgreSQL", "Sharepoint", "JQuery"],
    achievements: [
      "Conception et amélioration des applications métier internes.",
      "Approfondissement du C# et du framework .NET, avec une application des bonnes pratiques (code réutilisable, maintenable et testé).",
      "Correction de bugs, ajout de nouvelles fonctionnalités et amélioration des performances des outils existants.",
      "Collaboration en méthode Agile au sein d’une petite équipe.",
      "Accompagnement par mon tuteur et monté en compétences en parallèle du framework Symfony pour mon projet professionnel.",
    ],
    impact:
      "Cette alternance a été un tournant dans mon parcours, me permettant de maîtriser .NET, d’adopter des " +
      "pratiques de développement rigoureuses et d’obtenir mon diplôme de concepteur " +
      "développeur d’application grâce à mon projet professionnel.",
  },
  {
    id: "orange",
    title: "Développeur web",
    company: "Orange",
    location: "Angers, France",
    type: "Alternance",
    startDate: "2012-09-01",
    endDate: "2014-09-01",
    description:
      "Au sein d’Orange à Angers, j’ai intégré une équipe de 4-5 développeurs qui concevait historiquement " +
      "des applications sous Microsoft Access pour les collaborateurs. Avec le succès croissant de ces outils " +
      "à l’échelle régionale puis nationale, l’équipe a dû repenser son approche et migrer vers une solution plus " +
      "pérenne, en développant Agilis, un noyau basé sur Symfony permettant de créer des applications rapidement.",
    skills: ["Symfony", "PHP", "JavaScript", "jQuery", "MySQL"],
    achievements: [
      "Refonte des anciennes applications Microsoft Access en utilisant Symfony et le noyau interne Agilis",
      "Création de nouvelles applications métiers avec PHP et Symfony",
      "Participation à l'amélioration de la base technique pour accélérer la production d'applications",
      "Autonomie progressive sur la programmation, la conception d’architectures applicatives et la gestion de projet.",
    ],
    impact:
      "Cette première expérience en entreprise m’a permis d’apprendre rapidement les bases du développement, " +
      "de travailler sur un projet structurant et d’acquérir une autonomie technique au sein d’une grande entreprise.",
  },
];
